export function StepTitleSection({ title, description }: { title: string; description: string }) {
	return (
		<div className="flex flex-col items-center justify-center gap-[12px]">
			<p className=" font-semibold text-[24px] text-white leading-[100%]">{title}</p>
			<p className="text-center font-normal text-[16px] text-brand-gray-secondary leading-[140%]">
				{description}
			</p>
		</div>
	)
}
